import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "edit-medical-option",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title w-full pb-2" }, "オプションメニュー登録", -1)

import { onBeforeMount, ref, inject, computed } from "vue";
import { useRoute } from "vue-router";
import { get, set } from "@vueuse/core";
import { IMedicalOption } from "@/clinic/typings";
import { MedicalOptionServices } from "@/clinic/services";
import MedicalOptionsFormComponent from "./components/form.vue";
import Trash from "@/clinic/components/trash.vue";
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";
import { useToast } from "primevue/usetoast";


export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  setup(__props) {

const medicalOption = ref<IMedicalOption>({} as IMedicalOption);
const route = useRoute();
const toast = useToast();
const clinicId = ref(0);

const idUrl = computed((): number => {
  const { params } = route;
  const { id } = params;
  return id as unknown as number;
});

const onTrash = async () => {
  await MedicalOptionServices.trashMedicalOption(
    get(idUrl),
    {
      clinic_id: get(await get(clinicId)),
    },
    () => notifySuccessMsg(toast, "成功"),
    () => notityErrorMsg(toast, "エラー")
  );
};

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
  const { data } = await MedicalOptionServices.getOption(route.params.id, get(await get(clinicId)));
  set(medicalOption, get(data));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Trash, {
      id: _unref(get)(_unref(idUrl)),
      onTrash: onTrash
    }, null, 8, ["id"]),
    _createVNode(MedicalOptionsFormComponent, {
      model: medicalOption.value,
      clinicId: clinicId.value
    }, null, 8, ["model", "clinicId"])
  ]))
}
}

})